import type { ComponentPropsWithoutRef, ReactNode } from 'react'

type CustomerAreaPageLayoutProps = {
  children: ReactNode
  containerClassName?: string
} & Omit<ComponentPropsWithoutRef<'div'>, 'children' | 'className'>

const joinClassNames = (...classNames: Array<string | null | undefined | false>) =>
  classNames.filter(Boolean).join(' ')

export const CustomerAreaPageLayout = ({
  children,
  containerClassName,
  ...divProps
}: CustomerAreaPageLayoutProps) => (
  <div
    {...divProps}
    className="ca-page ca-theme-transition min-h-screen px-4 py-5 sm:px-6 sm:py-6 lg:px-8 xl:px-10 2xl:px-12"
  >
    <div className={joinClassNames('mx-auto w-full max-w-[1560px] space-y-4', containerClassName)}>{children}</div>
  </div>
)
